module.exports = __webpack_public_path__ + "1d5619cd804367cefe6da2d79289218a.svg";